import React, { Component } from 'react'

class Howitworks extends Component {
  render() {
    return (
      <div className='container'>
        <div className='inside centralize'>
          <h1>A cosa serve</h1>
          ClubHub server per gestire in toto una associaizone sportiva
          <h1>Quanto costa</h1>
          Costa 129,00 &euro; per ogni anno fiscale
          <h1>Vuoi provarlo?</h1>
          Accedi con questi dati se vuoi fare un test:
          <br />
          <br />
          <b>Utente amministratore</b>
          <br />
          <ul>
            <li>user: test_admin</li>
            <li>password: test_admin</li>
          </ul>
          <br />
          <b>Utente con limitazioni</b>
          <br />
          <ul>
            <li>user: test_user</li>
            <li>password: test_user</li>
          </ul>
          <h1>Come fare per attivare il proprio account</h1>
          Scrivere a mauro.sala@gmail.com per ricevere informazioni e modalità
          di accesso
        </div>
      </div>
    )
  }
}

export default Howitworks



// WEBPACK FOOTER //
// ./src/components/Howitworks.js